import { cn } from '../../lib/utils';

// Compact KPI tile. Number-first hierarchy, no icon chips or gradients.
export function Stat({ title, value, description, icon: Icon, trend, trendLabel, className }) {
  return (
    <div className={cn('bg-surface border border-line rounded-xl shadow-xs px-4 py-4', className)}>
      <div className="flex items-center justify-between">
        <p className="text-xs font-medium text-muted">{title}</p>
        {Icon && <Icon className="w-4 h-4 text-faint flex-shrink-0" />}
      </div>
      <p className="mt-2 text-[28px] leading-none font-semibold text-ink tnum">{value}</p>
      {description && <p className="mt-1.5 text-xs text-faint truncate">{description}</p>}
      {trendLabel && (
        <p className={cn(
          'mt-1.5 text-xs font-medium',
          trend === 'up' ? 'text-success-ink' : trend === 'down' ? 'text-danger-ink' : 'text-muted'
        )}>
          {trendLabel}
        </p>
      )}
    </div>
  );
}
